import React from 'react';
import {
  Box,
  Flex,
  SimpleGrid,
  Text,
  Input,
  InputGroup,
  InputLeftElement,
  Table,
  Thead,
  Tbody,
  Tr,
  Th,
  Td,
  TableContainer,
  Tag,
  Spinner,
  Link,
  HStack,
} from '@chakra-ui/react';
import { IconButton } from "@mui/material";
import SearchIcon from "@mui/icons-material/Search";

// import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
// import { faSearch } from '@fortawesome/free-solid-svg-icons';
import apiClient from '../../clients/apiClient.js';
import { OpenInNewOutlined } from '@mui/icons-material';
// import {
//   SearchIcon,
//   ChevronDownIcon,
//   MoreVerticalIcon,
// } from '@chakra-ui/icons';

const TaskTracker = () => {
  const [loading, setLoading] = React.useState(false);
  const [tasks, setTasks] = React.useState(null);
  const [searchQuery, setSearchQuery] = React.useState(''); // State for search query

  const [timezone, setTimezone] = React.useState(Intl.DateTimeFormat().resolvedOptions().timeZone);
  const [highlightedId, setHighlightedId] = React.useState("");

  const handleTimezoneChange = (event) => {
    setTimezone(event.target.value);
  };

  React.useEffect(() => {
    setLoading(true);

    apiClient
      .get('/task-tracker')
      .then((response) => {
        if (response.data.tasks === null) {
          setTasks([]);
        } else {
          setTasks(response.data.tasks); // Access the response data
        }
        setLoading(false);
      })
      .catch((error) => {
        console.error('Error fetching tasks:', error);
        setLoading(false); // Handle errors and stop loading
      });
  }, []);

  if (loading || tasks === null)
    return (
      <Flex width={'100%'} height="72vh" justifyContent={'center'} alignItems={"center"} py={20}>
        <Spinner
          thickness="4px"
          speed="0.65s"
          emptyColor="gray.200"
          color="blue.500"
          size="lg"
        />
      </Flex>
    );

  const filteredTasks = tasks.filter((task) =>
    task.task_name?.toLowerCase().includes(searchQuery.toLowerCase())
  );
  

  return (
    <Box p={0} height={'100vh'}>
        <Box paddingLeft={"24px"} backgroundColor={"#F6FAFF"} width={"100%"} maxW={"100%"}>
            <Box
                borderTopLeftRadius={"24px"}
                borderBottomLeftRadius={"24px"}
                backgroundColor={"white"}
                width={"100%"}
                maxW={"100%"}
                height={"100%"}
                paddingTop={"25px"}
                paddingLeft={"24px"}
                paddingRight={"8px"}
            >
      {/* Header */}
      <HStack>
        <Text fontSize="2xl" fontWeight="bold" mb={4}>
          Task Tracker
        </Text>
        <Box border="1px solid #ccc" borderRadius="md" p={1} bg="#f9f9f9" marginLeft={"auto"}>
          <select 
            value={timezone} 
            onChange={handleTimezoneChange} 
            style={{
              width: '100%',
              border: 'none',
              outline: 'none',
              backgroundColor: 'transparent',
              fontSize: '14px',
              padding: '4px',
            }}
          >
            {Intl.supportedValuesOf('timeZone').map((tz) => (
              <option key={tz} value={tz}>
                {tz}
              </option>
            ))}
          </select>
        </Box>
      </HStack>

      {/* Summary Cards */}
      <SimpleGrid columns={[1, 2, 4]} spacing={4} mb={6}>
        <Box
          p={4}
          border="1px solid"
          shadow="xs"
          borderRadius="md"
          cursor={'pointer'}
          bg="white"
          _hover={{
            bg: 'gray.100',
          }}
          borderColor="#2584FD"
        >
          <Text color="blue.500">All tasks</Text>
          <Text fontSize="2xl" fontWeight="bold" color="blue.500">
            {tasks.length}
          </Text>
        </Box>
        <Box p={4} bg="white" shadow="xs" borderRadius="md" cursor={'pointer'} _hover={{
          bg: 'gray.100',
        }}>
          <Text color="gray.500">Pinned</Text>
          <Text fontSize="2xl" fontWeight="bold" color="gray.500">
            0
          </Text>
        </Box>
        <Box p={4} bg="white" shadow="xs" borderRadius="md" cursor={'pointer'} _hover={{
          bg: 'gray.100',
        }}>
          <Text color="gray.500">Need attention</Text>
          <Text fontSize="2xl" fontWeight="bold" color="gray.500">
            0
          </Text>
        </Box>
        <Box p={4} bg="white" shadow="xs" borderRadius="md" cursor={'pointer'} _hover={{
          bg: 'gray.100',
        }}>
          <Text color="gray.500">Deadline approaching</Text>
          <Text fontSize="2xl" fontWeight="bold" color="gray.500">
            0
          </Text>
        </Box>
      </SimpleGrid>

      {/* Filters */}
      <Flex mb={6} align="center" gap={4}>
        <InputGroup maxW="300px">
          <InputLeftElement pointerEvents="none">
            {/* <IconButton icon={SearchIcon} style={{ color: 'grey' }} /> */}
            <IconButton style={{ color: 'grey' }} ><SearchIcon/></IconButton>
          </InputLeftElement>
          <Input
            placeholder="Search by task name"
            value={searchQuery}
            onChange={(e) => setSearchQuery(e.target.value)} // Update search query
            />
          </InputGroup>
          </Flex>

          <TableContainer
            bg="white"
            shadow="md"
            borderRadius="md"
            height="calc(100vh - 400px)"
            overflowY="auto"
          >
            <Table variant="simple">
            <Thead position="sticky" top={0} zIndex={1} bg="white">
            <Tr>
            <Th width="20%" textAlign="center">Tasks</Th>
            <Th width="20%" textAlign="center">Status</Th>
            <Th width="20%" textAlign="center">Stage</Th>
            {/* <Th>Next action</Th> */}
            <Th width="20%" textAlign="center">Created</Th>
            <Th width="20%" textAlign="center">Creator</Th>
            {/* <Th>Deadline</Th> */}
            {/* <Th width="25%"></Th> */}
            </Tr>
            </Thead>
            <Tbody>
            {filteredTasks.map((task, index) => {
              const {
                created_at,
                employee_first_name,
                status,
                employee_last_name,
                task_name,
                task_link,
              } = task;
                return (
                <Tr key={index}
                  style={{ 
                      backgroundColor: highlightedId === index ? "#F4F4F4" : "transparent" 
                  }}
                  onMouseEnter={() => setHighlightedId(index)}
                  onMouseLeave={() => setHighlightedId("")}
                >
                  <Td>
                  <Text fontWeight="bold">{task_name || '-'}</Text>
                  {
                  task_link && (
                  <Link href={task_link} fontSize="sm" paddingTop={"4px"}>
                    <HStack gap={1}>
                    <Text color={"#1D1D1D"} fontSize={"14px"} fontFamily={"sans-serif"}>
                      Go to task
                    </Text>
                    <IconButton sx={{ paddingX:0, paddingY:0.5}}>
                      <OpenInNewOutlined sx={{ padding:0, fontSize: 14, color: "#1476DE" }}/>
                    </IconButton>
                    </HStack>
                  </Link>
                  )
                  }
                  </Td>
                  <Td textAlign="center">
                  <Box
                    marginX={"auto"}
                    width={"80%"}
                    height={"4px"}
                    borderRadius={"4px"}
                    backgroundColor={"#E5E5E5"}
                  >
                    <Box
                      width={`${Math.min(hashString(task_name) % 200, 100)}%`}
                      height={"100%"}
                      borderRadius={"4px"}
                      backgroundColor={"#2584FD"}
                    />
                  </Box>
                  <HStack
                    justifyContent={"space-between"}
                    width={"80%"}
                    marginX={"auto"}
                    marginTop={"8px"}
                  >
                    <Text fontFamily={"sans-serif"} color={"#1D1D1D"} fontSize={"14px"} fontWeight={"400"} lineHeight={"18px"}>
                      {Math.min(hashString(task_name) % 200, 100)}% completed
                    </Text>
                  </HStack>
                  {/* {status} */}
                  </Td>
                  <Td textAlign={"center"}>
                    <Text>
                      {
                        Math.min(hashString(task_name) % 200, 100) >= 100 ? " Completed" :
                        Math.min(hashString(task_name) % 200, 100) > 90 ? " Outcome (Mandatory)" :
                        Math.min(hashString(task_name) % 200, 100) > 80 ? " Export" :
                        Math.min(hashString(task_name) % 200, 100) > 65 ? " Review & Collaborate" :
                        Math.min(hashString(task_name) % 200, 100) > 50 ? " Review & Collaborate" :
                        Math.min(hashString(task_name) % 200, 100) > 35 ? " Audit" :
                        Math.min(hashString(task_name) % 200, 100) > 20 ? " Prefilling" :
                        Math.min(hashString(task_name) % 200, 100) > 10 ? " Bid/No-Bid" : " Configuring Task"
                      }
                    </Text>

                  </Td>
                  {/* <Td>Waiting on stakeholders</Td> */}
                  <Td textAlign="center">{new Date(created_at).toLocaleString('en-GB', { timeZone: timezone, hour12: true, hour: '2-digit', minute: '2-digit', second: '2-digit', day: '2-digit', month: '2-digit', year: '2-digit' })}</Td>
                  <Td textAlign="center">{employee_first_name + ' ' + employee_last_name}</Td>
                  {/* <Td>27 Apr 2024</Td> */}
                  {/* <Td>
                  <IconButton
                  aria-label="Options"
                  //   icon={<MoreVerticalIcon />}
                  variant="ghost"
                  size="sm"
                  />
                  </Td> */}
                </Tr>
                );

        function hashString(str) {
          let hash = 0;
          for (let i = 0; i < str.length; i++) {
          hash = (hash << 5) - hash + str.charCodeAt(i);
          hash |= 0; // Convert to 32bit integer
          }
          return Math.abs(hash);
        }
            })}
          </Tbody>
        </Table>
      </TableContainer>
              
            <Box height={"24px"} width={"100%"} maxW={"100%"}>

            </Box>
            </Box>
          </Box>
    </Box>
  );
};

export default TaskTracker;
